import { useState } from "react"
import { IconCircleInfoOutline18 as Info } from "nucleo-ui-outline-18"

import { parseFieldPath } from "@productlane/lib"
import { Button, Dialog } from "@productlane/ui"

import type { SchemaField } from "../model/tool-schema-fields"
import { toast } from "@/components/toast"
import { FieldPathInput } from "../inputs/field-path-input"

interface Props {
	open: boolean
	onOpenChange: (open: boolean) => void
	toolName: string
	fields: readonly SchemaField[]
	taken: readonly string[]
	onAdd: (path: string) => void
}

/** Adds an argument the tool's schema does not advertise. */
export function ManualPathDialog({
	open,
	onOpenChange,
	toolName,
	fields,
	taken,
	onAdd,
}: Props) {
	const [path, setPath] = useState("")

	const submit = () => {
		const trimmed = path.trim()
		if (!trimmed) return
		if (!parseFieldPath(trimmed)) {
			toast.info({
				title: `"${trimmed}" is not a valid field path`,
				description: "Use dots for nested fields and [] for every list item.",
				icon: Info,
			})
			return
		}
		onAdd(trimmed)
		setPath("")
		onOpenChange(false)
	}

	return (
		<Dialog
			isOpen={open}
			onOpenChange={(next) => {
				onOpenChange(next)
				if (!next) setPath("")
			}}
			size="sm"
			title="Add an argument"
			description="Dots for nested fields, [] for every list item, * for any key."
			footer={
				<>
					<Button variant="outline" onClick={() => onOpenChange(false)}>
						Cancel
					</Button>
					<Button disabled={!path.trim()} onClick={submit}>
						Add argument
					</Button>
				</>
			}
		>
			<FieldPathInput
				name={`manual-path-${toolName}`}
				value={path}
				onChange={setPath}
				onSubmit={submit}
				fields={fields}
				taken={taken}
			/>
		</Dialog>
	)
}
